import axios from "axios";
import Config from "src/config";

const v2_actionListaAgentesAi = (clienteId) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/ai/agentes/${clienteId}`
        });
};

export default v2_actionListaAgentesAi;
